import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { environment } from "../../environments/environment";

import { TalentPool } from '../models/talentpool.model';

@Injectable()
export class TalentPoolService {

  private talentPoolsApi = environment.apiUrl + '/talent-pools';
  
  @Output() getHeaderText: EventEmitter<any> = new EventEmitter();

  constructor(private http: Http) { }

  getTalentPools(): Promise<any> {     
    const headers = new Headers({ 'Content-Type' : 'application/json', 'Authorization' : localStorage.getItem("idToken") } );  
      return this.http.get(this.talentPoolsApi,{headers: headers}).map(response => {
        return response;
      }).toPromise(); 
  }

  getOneTalentPool(id: string) {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.talentPoolsApi + '/' + id, {headers: headers});
  }

  addTalentPool(talentPool: Object) {
    //console.log(talentPool);
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.talentPoolsApi, talentPool, {headers: headers});
  }

  updateTalentPool(talentPoolId: string, talentPoolData) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.talentPoolsApi + '/' + talentPoolId, talentPoolData ,{headers: headers});
  }

  deleteTalentPool(talentPoolId: string){
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.delete(this.talentPoolsApi + '/' + talentPoolId ,{headers: headers});
  }
}


// WEBPACK FOOTER //
// ./src/app/services/talentpool.service.ts